module.exports = __webpack_public_path__ + "img/logo.91fc35e2.png";